import request from '@/router/axios'

let beforeValue = {}
const validate = {
  /**
   * 邮箱
   * @param {*} s
   */
  email(s) {
    return /(.)+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(
      s
    )
  },

  /**
   * 手机号码
   * @param {*} s
   */
  mobile(s) {
    return /^1[0-9]{10}$/.test(s)
  },

  /**
   * 电话号码
   * @param {*} s
   */
  phone(s) {
    return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
  },

  /**
   * URL地址
   * @param {*} s
   */
  isURL(s) {
    return /^http[s]?:\/\/.*/.test(s)
  },

  isValidUsername(str) {
    const valid_map = ['sys', 'editor']
    return valid_map.indexOf(str.trim()) >= 0
  },

  /* 合法uri */
  checkURL(textval) {
    const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
    return urlregex.test(textval)
  },

  /* 小写字母 */
  checkLowerCase(str) {
    const reg = /^[a-z]+$/
    return reg.test(str)
  },

  /* 大写字母 */
  checkUpperCase(str) {
    const reg = /^[A-Z]+$/
    return reg.test(str)
  },

  /* 大小写字母 */
  checkAlphabets(str) {
    const reg = /^[A-Za-z]+$/
    return reg.test(str)
  },

  /* 验证pad还是pc */
  checkPcOrPad() {
    const userAgentInfo = navigator.userAgent
    const Agents = [
      'Android',
      'iPhone',
      'SymbianOS',
      'Windows Phone',
      'iPad',
      'iPod',
    ]
    let flag = true
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false
        break
      }
    }
    return flag
  },
  /**
   * check email
   * @param email
   * @returns {boolean}
   */
  checkEmail(email) {
    const re = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  },

  /**
   * 判断身份证号码
   */
  cardId(code) {
    let list = []
    let result = true
    let msg = ''
    let city = {
      11: '北京',
      12: '天津',
      13: '河北',
      14: '山西',
      15: '内蒙古',
      21: '辽宁',
      22: '吉林',
      23: '黑龙江 ',
      31: '上海',
      32: '江苏',
      33: '浙江',
      34: '安徽',
      35: '福建',
      36: '江西',
      37: '山东',
      41: '河南',
      42: '湖北 ',
      43: '湖南',
      44: '广东',
      45: '广西',
      46: '海南',
      50: '重庆',
      51: '四川',
      52: '贵州',
      53: '云南',
      54: '西藏 ',
      61: '陕西',
      62: '甘肃',
      63: '青海',
      64: '宁夏',
      65: '新疆',
      71: '台湾',
      81: '香港',
      82: '澳门',
      91: '国外 ',
    }
    if (!this.checkNull(code)) {
      if (code.length == 18) {
        if (!code || !/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {
          msg = '证件号码格式错误'
        } else if (!city[code.substr(0, 2)]) {
          msg = '地址编码错误'
        } else {
          // 18位身份证需要验证最后一位校验位
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2, 'x']
          let sum = 0
          let ai = 0
          let wi = 0
          for (let i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          if (parity[sum % 11] != code[17]) {
            msg = '证件号码校验位错误'
          } else {
            result = false
          }
        }
      } else {
        msg = '证件号码长度不为18位'
      }
    } else {
      msg = '证件号码不能为空'
    }
    list.push(result)
    list.push(msg)
    return list
  },

  isMobile(rule, value, callback) {
    if (this.checkNotNull(value)) {
      let rs = this.checkMobile(value)
      if (rs && rs[0]) {
        callback(new Error(rs[1]))
        return
      }
    }
    callback()
  },

  /**
   * 判断手机号码是否正确
   */
  checkMobile(phone) {
    let list = []
    let result = true
    let msg = ''
    let isPhone = /^0\d{2,3}-?\d{7,8}$/
    //增加134 减少|1349[0-9]{7}，增加181,增加145，增加17[678]
    let isMob = /^((\+?86)|(\(\+86\)))?(13[0123456789][0-9]{8}|15[012356789][0-9]{8}|18[012356789][0-9]{8}|14[57][0-9]{8}|17[3678][0-9]{8})$/
    if (!this.checkNull(phone)) {
      if (phone.length == 11) {
        if (isPhone.test(phone)) {
          msg = '手机号码格式不正确'
        } else {
          result = false
        }
      } else {
        msg = '手机号码长度不为11位'
      }
    } else {
      msg = '手机号码不能为空'
    }
    list.push(result)
    list.push(msg)
    return list
  },

  /**
   * 判断姓名是否正确
   */
  checkName(name) {
    let regName = /^[\u4e00-\u9fa5]{2,4}$/
    if (!regName.test(name)) return false
    return true
  },

  /**
   * 判断是否为整数
   */
  isDigits(rule, value, callback) {
    if (this.checkNotNull(value)) {
      let rs = this.checkDigits(value)
      if (rs) {
        callback(
          new Error(
            this.checkNotNull(rule.message) ? rule.message : '请输入整数'
          )
        )
        return
      }
    }
    callback()
  },

  /**
   * 判断是否为整数
   */
  checkDigits(num) {
    let regName = /[^\d]/g
    if (!regName.test(num)) return false
    return true
  },

  isNumber(rule, value, callback) {
    if (this.checkNotNull(value)) {
      let rs = this.checkNumber(value)
      if (rs) {
        callback(
          new Error(
            this.checkNotNull(rule.message) ? rule.message : '请输入数字'
          )
        )
        return
      }
    }
    callback()
  },

  /**
   * 判断是否为小数
   */
  checkNumber(num) {
    let regName = /[^\d.]/g
    if (!regName.test(num)) return false
    return true
  },

  /**
   * 判断是否为小数
   */
  checkNumord(num, type) {
    let regName = /[^\d.]/g
    if (type == 1) {
      if (!regName.test(num)) return false
    } else if (type == 2) {
      regName = /[^\d.]/g
      if (!regName.test(num)) return false
    }
    return true
  },

  /**
   * 判断是否为空
   */
  checkNull(val) {
    if (typeof val === 'boolean') {
      return false
    }
    if (typeof val === 'number') {
      return false
    }
    if (val instanceof Array) {
      if (val.length == 0) return true
    } else if (val instanceof Object) {
      if (JSON.stringify(val) === '{}') return true
    } else {
      if (
        val == 'null' ||
        val == null ||
        val == 'undefined' ||
        val == undefined ||
        val == ''
      )
        return true
      return false
    }
    return false
  },

  /**
   * 判断是否为空
   */
  checkNotNull(val) {
    return !this.checkNull(val)
  },

  checkUniqueField(url) {
    return request({
      url: url,
      method: 'get',
    })
  },
  isUnique(rule, value, callback, url) {
    if (this.checkNotNull(value) && value != beforeValue[rule.field]) {
      if (this.checkNull(url)) {
        url = rule.url
      }
      url += '&' + rule.field + '=' + value
      this.checkUniqueField(url).then((rs) => {
        beforeValue[rule.field] = value
        if (!rs) {
          callback(
            new Error(
              this.checkNotNull(rule.message) ? rule.message : '已存在，请修正'
            )
          )
        } else {
          callback()
        }
      })
    } else {
      callback()
    }
  },
  /**
   * 验证金额为22.00
   */
  vaildMoney(value, type = 0) {
    //如果输入非数字，则替换为''
    let temp = ''
    if (type == 0) {
      // 没有负数
      // eslint-disable-next-line no-useless-escape
      temp = value.toString().replace(/[^\d\.]/g, '')
    } else {
      // eslint-disable-next-line no-useless-escape
      temp = value.toString().replace(/[^-\d\.]/g, '')
      temp = value.toString().replace(/-{2,}/g, '-')
      temp = value.toString().replace(/^-\d-/g, '-')
    }
    //必须保证第一个为数字而不是.
    temp = temp.replace(/^\./g, '')
    //前两位不能是0加数字
    temp = temp.replace(/^0\d[0-9]*/g, '')
    //保证只有出现一个.而没有多个.
    temp = temp.replace(/\.{2,}/g, '.')
    //保证.只出现一次，而不能出现两次以上
    temp = temp
      .replace('.', '$#$')
      .replace(/\./g, '')
      .replace('$#$', '.')
    //只能输入两位小数
    temp = temp.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
    return temp
  },
  /**
   * 验证价格
   */
  checkMoney(value, max) {
    let reg = /^\d+(\.\d){0,1}\d{0,1}$/;
    if (!reg.test(value)) {
      return '请输入正确的价格'
    }
    if (!this.checkNull(max) && parseFloat(value) >= parseFloat(max)) {
      return '价格不可超过' + max
    }
    return false
  },
  /**
   * 验证开票金额
   */
  checkAmount(value, max) {
    let reg = /^\d+(\.\d){0,1}\d{0,1}$/;
    if (!reg.test(value)) {
      return '请输入正确的金额'
    }
    if (value == 0) {
      return '请输入正确的金额'
    }
    if (!this.checkNull(max) && parseFloat(value) > parseFloat(max)) {
      return '金额不可超过可开票金额'
    }
    return false
  },

  /**
   * 验证比率
   */
   checkRate(value) {
    let reg = /^\d+(\.\d){0,1}\d{0,1}$/;
    if (!reg.test(value)) {
      return '请输入正确比率'
    }
    return false
  },


  /**
   * 验证正数
   */
  checkNum(value) {
    let reg = /^\d+(\.\d){0,1}\d{0,1}$/;
    if (!reg.test(value)) {
      return '请输入正确数据'
    }
    return false
  },
  /**
   * 验证合同金额
   */
  checkBusMoney(value, max) {
    let reg = /^\d+(\.\d){0,1}\d{0,1}$/;
    if (!reg.test(value)) {
      return '请输入正确的金额'
    }
    if (!this.checkNull(max) && parseFloat(max) > parseFloat(value)) {
      return '合同金额不可小于以开票金额'
    }
    return false
  },
  /**
   * 校验链接
   */
  checkMediaUrl(mediaType, value) {
    var result = true;
    switch (mediaType) {
      case 'wechat':
        result = true
        break;
      case 'weibo':
        result = /^https:\/\/(www.)?weibo.com\/u\/(\d){1,24}$/.test(value)
        break;
      case 'redbook':
        result = /^https:\/\/www\.xiaohongshu\.com\/user\/profile\/[0-9a-f]{24}$/.test(value)
        break;
      case 'tiktok':
        result = /^https:\/\/v\.douyin\.com\/[0-9a-zA-Z]{7}\/$/.test(value)
        break;
      case 'bilibili':
        result = /^https:\/\/space\.bilibili\.com\/\d{1,}$/.test(value)
        break;
      case 'kwai':
        // result = /^https:\/\/live\.kuaishou\.com\/profile\/.{1,}$/.test(value)
        result = true
        break;
      case 'taobao':
        result = /^\d+$/.test(value)
        break;
    }
    return result;
  },
  /**
   * 校验ID
   */
  checkMediaID(mediaType, value) {
    var result = true;
    switch (mediaType) {
      case 'wechat':
        result = true
        break;
      case 'taobao':
        result = /^\d+$/.test(value)
        break;
      default:
        result = true;
        break;
    }
    return result;
  },
  /**
   * 过滤form的空值
   */
  removeFilterNull(form) {
    let result = {};
    for (let k in form) {
      if (typeof form[k] == 'string') {
        if (!this.checkNull(form[k]) && !this.checkNull(form[k].trim())) {
          result[k] = form[k].trim();
        }
      } else {
        if (form[k] instanceof Array) {
          if (form[k].length > 0) {
            result[k] = form[k];
          }
        } else {
          result[k] = form[k];
        }
      }
    }
    return result;
  },
  /**
   * 过滤数组中的null
   */
  removeArrayNUll(list) {
    list = list.filter(
      (n) => n
    );
    return list
  },
  GetQueryString(url,param) { //param为要获取的参数名 注:获取不到是为null
    var currentUrl = url; //获取当前链接
    var arr = currentUrl.split("?");//分割域名和参数界限
    if (arr.length > 1) {
        arr = arr[1].split("&");//分割参数
        for (var i = 0; i < arr.length; i++) {
            var tem = arr[i].split("="); //分割参数名和参数内容
            if (tem[0] == param) {
                return tem[1];
            }
        }
        return null;
    }
    else {
        return null;
    }
  },



  /**
   * 验证价格
   */
   checkInteger(num) {
    let regName = /[^\d]/g
    if (!regName.test(num)) return false
    return '请输入正整数'
  },
}
export default validate
